// API Configuration
const getApiUrl = () => {
  // Check for environment variable first (for VPS deployment)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production without env var, try to detect backend URL
  if (process.env.NODE_ENV === 'production') {
    // If backend is on same domain but different port, or if using relative URLs
    // Return empty string to use relative URLs (works if backend serves static files)
    return '';
  }
  
  // In development, use proxy (empty string means relative URL)
  return '';
};

export const API_BASE_URL = getApiUrl();
export const UPLOADS_BASE_URL = getApiUrl(); // Same as API for uploads

// Helper function to get upload URL
export const getUploadUrl = (filename) => {
  if (!filename) return null;
  const base = UPLOADS_BASE_URL || '';
  // Remove any leading slashes from filename to avoid double slashes
  const cleanFilename = filename.startsWith('/') ? filename.substring(1) : filename;
  const url = `${base}/uploads/${cleanFilename}`;
  // Always log in production for debugging VPS issues
  console.log('Upload URL:', url, 'Base:', base || '(relative)', 'Filename:', cleanFilename);
  return url;
};
